import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ONBOARD_CONSTANTS } from '../../../app.constants';
import { environment } from './../../../../environments/environment';
import { HttpService } from '../../../services/http.service';
import { SharedService } from '@flysas/payment';
import { AppService } from '../../../app.service';
import { PaymentService } from '../payment.service';

@Injectable()
export class CheckoutReviewService {

  constructor(
    private httpService: HttpService,
    private sharedService: SharedService,
    private appService: AppService,
    private paymentService: PaymentService
  ) { }

  callCheckoutReview(): Observable<any> {
    const request = {
      url: this.createReviewURLRequest(),
      data: {
        'voucher': this.sharedService.getcheckoutReviewRequest().voucher,
        'captchaResponse': this.sharedService.getcheckoutReviewRequest().captchaResponse
      } 
    };
    return this.httpService.postData(request)
      .map(reviewRes => {
        return reviewRes;
      })
      .catch((error: any) => {
        return Observable.throw(error);
      });

  }

  createReviewURLRequest(): string {
    const checkoutId = this.appService.getCheckOutId();
    const baseUrl = environment.apiBaseUrl;
    const reserveUrl =
      ONBOARD_CONSTANTS.REVIEW_URL
        .replace('<<CHECKOUTID>>', checkoutId);
    return baseUrl + reserveUrl;
  }

  resetGiftCardDetails() {
    this.paymentService.setGiftCardTotal(null);
    this.sharedService.setZeroTotalPayableAmount(false);
    this.sharedService.setVoucher(null);
    this.sharedService.setReviewErrors(null);
    this.sharedService.setCallAncCheckoutReview(false);
    this.paymentService.setPaymentInfo(null);
    this.paymentService.setIsGiftCard(false);
    this.sharedService.setVoucherReachedMaxLimit(false);
    this.paymentService.setLoaderPayBtn(false);
    this.sharedService.setEmptyVoucher(false);
  }
  }

